<ce-template-header-scroll ceDocumentResizeObserver (documentResizeEvent)="itemResizeEvent($event)" [scrollId]="scrollSectionId">
    <div slot="header">
        <div class="flex-row flex-middle flex-between u-spacing-lg-mv">
            <h1 class="u-text-title-sm">Product updates</h1>
        </div>
        <div class="u-border-bottom-secondary u-hide-lt-sm">
            <ce-tab-group [tabIndex]="tabIndexFromRoute()" [tabs]="horizontalTabs()" tabType="section" elementType="button" (tabIdSelected)="onTabSelection($event)" class="u-spacing-sm-mh" />
        </div>
        <ce-tab-group [tabIndex]="tabIndexFromRoute()" [tabs]="horizontalTabs()" tabType="page" elementType="anchor" (tabIdSelected)="onTabSelection($event)" class="u-hide-gt-sm" />
    </div>
    <div slot="scroll">
        @if (!hasError()) {
            <section @fadeInOnEnter [ngClass]="{ isScrolled: isScrolled() }" id="chargeyeFeed">
                <ce-notification-list [notificationData]="releaseNoteDataComputed()" (notificationSelected)="notificationIdSelected($event)" [notificationIdSelected]="selectedItemId()" variant="article" />
            </section>
        } @else {
            <ce-empty-state type="not-found" size="md">
                <h1 ce-empty-state-title>No updates found</h1>
                <p ce-empty-state-description>Could not load product updates. Please try again later.</p>
            </ce-empty-state>
        }
    </div>
</ce-template-header-scroll>
